import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Minnesota State Portal": {
    parameters: {
      linkUrls: ["https://minnesota.hazconnect.com/Account/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "MN",
  },
};
